/**
 * Gallery Schema
 * Schema-driven settings for image gallery section
 */
export default {
  id: 'gallery',
  version: 1,
  title: 'Галерея',
  description: 'Блок с галереей изображений',
  icon: 'Images',
  category: 'media',

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Галерея',
          defaults: { size: '3xl', weight: 'bold', color: 'foreground' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Описание галереи',
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'style',
          type: 'select',
          label: 'Стиль',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'grid', label: 'Сетка', icon: 'LayoutGrid' },
            { value: 'slider', label: 'Слайдер', icon: 'GalleryHorizontal' },
            { value: 'carousel', label: 'Листание', icon: 'GalleryHorizontalEnd' }
          ]
        },
        {
          key: 'columns',
          type: 'select',
          label: 'Колонок',
          visible: (data) => (data?.style || 'grid') === 'grid',
          options: [
            { value: 2, label: '2' },
            { value: 3, label: '3' },
            { value: 4, label: '4' },
            { value: 5, label: '5' }
          ]
        },
        {
          key: 'gap',
          type: 'select',
          label: 'Отступ',
          visible: (data) => (data?.style || 'grid') === 'grid',
          options: [
            { value: 8, label: 'S' },
            { value: 16, label: 'M' },
            { value: 24, label: 'L' },
            { value: 32, label: 'XL' }
          ]
        },
        {
          key: 'rounded',
          type: 'checkbox',
          label: 'Скруглённые углы',
          visible: (data) => (data?.style || 'grid') === 'grid',
          default: true
        }
      ]
    },
    {
      group: 'Изображения',
      fields: [
        {
          key: 'images',
          type: 'list',
          label: 'Изображения',
          addLabel: 'Добавить',
          itemLabel: 'Изображение',
          itemFields: [
            {
              key: 'src',
              type: 'image',
              label: 'Изображение'
            },
            {
              key: 'alt',
              type: 'input',
              label: 'Alt текст',
              placeholder: 'Описание изображения'
            },
            {
              key: 'caption',
              type: 'input',
              label: 'Подпись',
              placeholder: 'Подпись к изображению'
            }
          ]
        }
      ]
    }
  ],

  default: {
    title: { text: 'Галерея' },
    subtitle: { text: 'Посмотрите наши работы' },
    style: 'grid',
    columns: 3,
    gap: 16,
    rounded: true,
    images: [
      { id: '1', src: 'https://placehold.co/800x600/1a1a2e/ffffff?text=Image+1', alt: 'Изображение 1', caption: '' },
      { id: '2', src: 'https://placehold.co/800x600/1a1a2e/ffffff?text=Image+2', alt: 'Изображение 2', caption: '' },
      { id: '3', src: 'https://placehold.co/800x600/1a1a2e/ffffff?text=Image+3', alt: 'Изображение 3', caption: '' }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      if (migrated.images) {
        migrated.images = migrated.images.map(img => ({
          ...img,
          id: img.id || Date.now().toString()
        }));
      }
      return migrated;
    }
    return data;
  }
};
